module.exports = __webpack_public_path__ + "img/cv.4696b996.svg";